var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-video"},[_c('div',{staticClass:"container",class:{
      'container--full': _vm.config['wildscreen'] || _vm.config['fullscreen'],
    }},[(_vm.config['show_type'] === 'default')?_c('default-video',{attrs:{"config":_vm.config}}):_c('background-video',{attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }